import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Slices/userSlice";
import { reset } from "../Redux/Slices/boardsSlice";
import axios from "axios";
import { useHistory } from "react-router-dom";

axios.defaults.baseURL =
  "https://project-manager-backend-afgb.onrender.com/user/";

export default function ProfileBox() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = React.useState({ name: "", email: "" });
  const dispatch = useDispatch();
  const history = useHistory();

  const open = Boolean(anchorEl);
  const color = useSelector((state) => state.user.userInfo.color);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get("/profile", { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        setUser({
          name: response.data.name,
          email: response.data.email,
        });
      })
      .catch((error) => console.error("Error fetching profile:", error));
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account">
          <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
            <Avatar
              sx={{
                width: 40,
                height: 40,
                bgcolor: " #056dc2;",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              {user.name ? user.name[0].toUpperCase() : "U"}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            width: 250,

            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.3 }}>
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#056dc2",
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            {user.name ? user.name[0].toUpperCase() : "U"}
          </Avatar>
          <Box>
            <strong>{user.name}</strong>
            <p style={{ fontSize: "0.85rem", color: "#666", margin: 0 }}>
              {user.email}
            </p>
          </Box>
        </Box>
        <hr style={{ margin: "8px 0", borderColor: "#ddd" }} />
        <MenuItem onClick={() => history.push("/profile")}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Manage Account
        </MenuItem>
        <hr style={{ margin: "8px 0", borderColor: "#ddd" }} />

        <MenuItem
          onClick={() => {
            dispatch(reset());
            dispatch(logout());
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
